import * as constants from "./userListConstants";

export const setSearchTerm = (searchTerm) => ({
    type: constants.SEARCH_USERS,
    payload: { searchTerm },
});

export default setSearchTerm;
